import { render, staticRenderFns } from "./modalAnularCredito.vue?vue&type=template&id=2c52cfc8"
import script from "./modalAnularCredito.vue?vue&type=script&lang=js"
export * from "./modalAnularCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports